import { BANDS3, MATRIX, SCENARIOS, TIERS, scenarioText } from "../lib/bopta";

export const ScenarioCard = ({ k, manager, testid, id }) => {
  const s = scenarioText(k, manager);
  return (
    <div id={id} className="panel avoid-break scroll-mt-24 p-7" data-testid={testid}>
      <p className="text-xs font-bold" style={{ color: s.tone }}>Scenario {k} · {s.tag}</p>
      <p className="mt-2 text-2xl font-bold">{s.name}</p>
      <p className="mt-3 muted">{s.reality}</p>
      <p className="mt-3 text-sm"><b>Impact:</b> <span className="muted">{s.impact}</span></p>
      <p className="mt-3 text-sm"><b>Focus:</b> <span className="muted">{s.focus}</span></p>
    </div>
  );
};

const Cell = ({ k, active, onSelect }) => {
  const s = SCENARIOS[k];
  const on = active === k;
  const dim = active && !on;
  const cls = `flex min-h-[64px] min-w-0 flex-col justify-center break-words [hyphens:auto] rounded-lg border p-1.5 sm:p-2 text-left text-[10px] sm:text-xs transition-[opacity,transform] ${onSelect ? "hover:-translate-y-0.5" : ""}`;
  const style = on ? { background: s.tone, borderColor: s.tone, color: "#fff" } : { background: "#F7F7F3", borderColor: "#E4E4DE", opacity: dim ? 0.55 : 1 };
  const body = <><b className="text-sm">{k}</b><span className="leading-tight">{s.name}</span></>;
  return onSelect
    ? <button type="button" className={cls} style={style} onClick={() => onSelect(k)} data-testid={`matrix-cell-${k}`}>{body}</button>
    : <div className={cls} style={style} data-testid={`matrix-cell-${k}`} aria-current={on || undefined}>{body}</div>;
};

export const ScenarioMatrix = ({ active, onSelect, manager }) => (
  <div className="avoid-break" data-testid="scenario-matrix">
    <div className="grid grid-cols-[minmax(0,64px)_repeat(3,minmax(0,1fr))] sm:grid-cols-[minmax(0,90px)_repeat(3,minmax(0,1fr))] gap-1.5 sm:gap-2">
      <span className="text-[10px] uppercase tracking-wider muted self-end">{manager ? "Team role" : "Role"} ↓ · Autonomy →</span>
      {BANDS3.map(([b, r]) => <span key={b} className="text-center text-xs font-semibold">{b}<span className="block font-normal muted">{r}</span></span>)}
      {TIERS.map(([t, label, sub]) => [
        <span key={t} className="self-center text-xs font-semibold">{label}<span className="block font-normal muted">{sub}</span></span>,
        ...MATRIX[t].map((k) => <Cell key={k} k={k} active={active} onSelect={onSelect} />),
      ])}
    </div>
  </div>
);
